import { memo } from "react";
import { Box, Radio, Typography } from "@mui/material";
import theme from "../theme.js";

const Tier = ({ tier, price, allowance, selected, onSelect, customPlan = false }) => (
	<Box component="label" sx={{
		display: "flex", flexDirection: "column", cursor: "pointer", minWidth: 0,
		border: "1px solid", borderColor: selected ? theme.palette.primary.main : "#d5e1eb",
		boxShadow: selected ? `inset 0 0 0 1px ${theme.palette.primary.main}` : "none",
		borderRadius: "10px", p: 2, bgcolor: selected ? "#f0f7fa" : "#9eb3c5",
		"&:hover": { borderColor: theme.palette.primary.main },
		"&:focus-within": { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: "3px" },
	}}>
		<Box display="flex" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
			<Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#63778a" }}>Tier {tier}</Typography>
			<Radio name="team-tier" value={tier} checked={selected} onChange={onSelect}
				inputProps={{ "aria-label": `Tier ${tier}: ${customPlan ? "Enterprise, contact sales" : `${allowance}, €${price} per month`}` }}
				sx={{ p: 0, "& .MuiSvgIcon-root": { fontSize: "19px" } }} />
		</Box>
		<Typography sx={{ color: theme.palette.primary.main, fontSize: "22px", fontWeight: 700 }}>{customPlan ? "Enterprise" : allowance}</Typography>
		<Typography sx={{ color: "#63778a", fontSize: "12px", mt: 0.5, mb: 2.5 }}>
			{customPlan ? "For larger codebases" : "Across all your repositories"}
		</Typography>
		<Typography sx={{ mt: "auto", color: "#263440", fontSize: customPlan ? "20px" : "24px", fontWeight: 700 }}>
			{customPlan ? "Contact sales" : <>€{price} <Box component="span" sx={{ color: "#63778a", fontSize: "12px", fontWeight: 400 }}>/ month</Box></>}
		</Typography>
	</Box>
);

export default memo(Tier);
